:host {
  .icon {
    fill: var(--hcl-color-primary);
  }

  .primary {
    .icon {
      fill: var(--hcl-color-secondary);
    }
  }
  hcl-sdk-icon-map_geoloc {
    stroke: var(--hcl-color-primary);
    fill: none;
    display: block;

    > svg {
      display: block;
    }
  }

  hcl-sdk-icon-sort {
    display: grid;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  hcl-sdk-icon-circular {
    display: inline-block;
    animation: keyframes-circular-rotate 1.4s linear infinite;
    & > svg {
      display: block;
    }
    circle {
      animation: keyframes-circular-dash 1.4s ease-in-out infinite;
      stroke-dasharray: 80px, 200px;
      stroke-dashoffset: 0px;
    }
  }

  @-webkit-keyframes keyframes-circular-rotate {
    0% {
      transform-origin: 50% 50%;
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes keyframes-circular-rotate {
    0% {
      transform-origin: 50% 50%;
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes keyframes-circular-dash {
    0% {
      stroke-dasharray: 1px, 200px;
      stroke-dashoffset: 0px;
    }
    50% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -15px;
    }
    100% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -125px;
    }
  }
  @keyframes keyframes-circular-dash {
    0% {
      stroke-dasharray: 1px, 200px;
      stroke-dashoffset: 0px;
    }
    50% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -15px;
    }
    100% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -125px;
    }
  }
}

